import { Box, Stack, Typography } from "@mui/material";
import type { TransactionDetailDto } from "Infrastructure/Api/Api";
import { formatCurrency } from "Utils/CurrencyUtils";
import { Resources, useResource } from "Translations/Resources";

type InfoRowProps = {
  label: string;
  value: string;
};

const InfoRow = ({ label, value }: InfoRowProps) => (
  <Box display="flex" justifyContent="space-between" gap={7}>
    <Typography fontSize={16}>{label}</Typography>
    <Typography fontSize={18} fontWeight={500}>
      {value}
    </Typography>
  </Box>
);

type Props = {
  transactionsDetail: TransactionDetailDto;
  paypointName?: string | null;
};

export const TransactionInformation = ({
  paypointName,
  transactionsDetail: {
    creditorIBAN,
    paymentReference,
    amount,
    currencyCode,
    noteForDebtor,
    publicID,
  },
}: Props) => {
  const { t } = useResource();

  return (
    <Stack gap={2}>
      {paypointName && <InfoRow label="Paypoint" value={paypointName} />}
      {creditorIBAN && <InfoRow label="IBAN" value={creditorIBAN} />}
      {paymentReference && (
        <InfoRow
          label={t(Resources.Common.VariableSymbol)}
          value={paymentReference}
        />
      )}
      {amount && (
        <InfoRow
          label={t(Resources.Common.Amount)}
          value={formatCurrency({ amount, currencyCode })}
        />
      )}
      {noteForDebtor && (
        <InfoRow label={t(Resources.Common.Note)} value={noteForDebtor} />
      )}
      {publicID && (
        <InfoRow
          label={t(Resources.Common.TransactionPaymentCode)}
          value={publicID}
        />
      )}
    </Stack>
  );
};
